import React, { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export function SearchableSelect({ options, value, onSelect, placeholder = "Search...", emptyText = "No results.", className, triggerClassName, testId }) {
  const [open, setOpen] = useState(false);

  const selected = options.find(o => o.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline" role="combobox" aria-expanded={open}
          className={cn("w-full justify-between h-8 text-xs font-normal", !selected && "text-muted-foreground", triggerClassName)}
          data-testid={testId}
        >
          <span className="truncate">{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="ml-1 h-3 w-3 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn("p-0 w-[var(--radix-popover-trigger-width)]", className)} align="start">
        <Command>
          <CommandInput placeholder={placeholder} className="h-8 text-xs" />
          <CommandList>
            <CommandEmpty className="text-xs py-4 text-center">{emptyText}</CommandEmpty>
            <CommandGroup className="max-h-60 overflow-auto">
              {options.map(opt => (
                <CommandItem
                  key={opt.value}
                  value={opt.searchStr || opt.label}
                  onSelect={() => { onSelect(opt.value); setOpen(false); }}
                  className="text-xs"
                  data-testid={`option-${opt.value}`}
                >
                  <Check className={cn("mr-1.5 h-3 w-3", value === opt.value ? "opacity-100" : "opacity-0")} />
                  <div className="min-w-0">
                    <span className="font-medium">{opt.label}</span>
                    {opt.sub && <span className="block text-[10px] text-muted-foreground truncate">{opt.sub}</span>}
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
